import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccessToken, OauthService, Profile } from 'ng2-kalieki-acs';
import { TokenManager } from './shared/tokenManager';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { LensCatalogBusinessService } from './shared/lens-catalog-business.service';
import { SubscriptionsContainer } from './shared/subscriptions-container';
import { TokenProfile } from './shared/token-profile';
import { LabOrderBusinessService } from './shared/lab-order-business.service';
import { LabIdManager } from './shared/labIdManager';
import { jwtDecode } from 'jwt-decode';

// Parent component where everything hangs off of.
// Has Login / Logout hooks into the ACS2-Kalieki async calls using observables
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  restrictedTitle: string;
  restrictedSubtitle: string;
  state: string;
  loggedIn: Boolean;
  dynaTraceScript: HTMLScriptElement;
  subs = new SubscriptionsContainer();

  constructor(
    private oauth: OauthService,
    private lensCatalogBusinessService: LensCatalogBusinessService,
    private labOrderBusinessService: LabOrderBusinessService,
    private _router: Router
  ) {
    this.oauth.base = environment.oauthBaseUrl;
    this.oauth.clientId = 'lab-portal-ui';
    this.oauth.scopes = [
      'read:laborder',
      'openid',
      'profile',
      'auth_ecp',
      'write:laborder',
      'read:reference.lens',
      'read:ef.lab_payment_documents',
    ];
    this.oauth.redirect_uri = environment.acsRedirectUrl;

    // Add script for dynatrace script for staging and prod
    if (environment.dynaTraceUrl) {
      this.dynaTraceScript = document.createElement('script');
      this.dynaTraceScript.type = 'text/javascript';
      this.dynaTraceScript.src = environment.dynaTraceUrl;
      this.dynaTraceScript.crossOrigin = 'anonymous';
      document.body.appendChild(this.dynaTraceScript);
    }

    this.setUpOAuth();
    this.openDoor();
    this.closeDoor();
  }

  ngOnInit(): void {
    console.log('In AppComponent ngOnInit');

    this.subs.add = this.oauth.onLoggedIn.subscribe((token: AccessToken) => {
      // trigger calls to get data from lens catalog api
      this.lensCatalogBusinessService.initialDataLoad();
      this.labOrderBusinessService.initialDataLoad();
    });
  }

  ngOnDestroy(): void {
    console.log(' App Component - ngOnDestroy ');
    this.subs.dispose();
  }

  public setUpOAuth() {
    // Kalieki library provides observables so we can access them when the async call returns
    // the onLoggeIn, onLoggedOut, onProfileReceived are the 3 hooks to watch out for.
    // on login we obtain a token and save it
    this.subs.add = this.oauth.onLoggedIn.subscribe((token: AccessToken) => {
      console.log('****Token: ', token.toString());
      TokenManager.token = token.toString();
      console.log('TokenManager: ', TokenManager.token);

      const parsedToken = token
        ? (jwtDecode(token.toString()) as TokenProfile)
        : ({} as TokenProfile);

      if (parsedToken && parsedToken.principal) {
        LabIdManager.labId = parsedToken.principal.toString().substr(0,4);
        console.log('****LabId: ', LabIdManager.labId);
      }

      console.log('Checking for Access Permission');
      if (!parsedToken.efan || !parsedToken.efan.toUpperCase().startsWith('LAB')) {
        console.log('Access Denied for Non Lab User ' + parsedToken.efan);
        alert('Access Denied for Non Lab User');
        this.oauth.signOut();
        return;
      }

      this.loggedIn = true;
    });
    // on log out ensure the token is reset
    this.subs.add = this.oauth.onLoggedOut.subscribe((event) => {
      if(event && event.logout === 'true') {
        this.closeDoor();
        TokenManager.token = null;
        LabIdManager.labId = null;
        this.loggedIn = false;
        if(environment.welcomeLogOutUrl.indexOf('home') >= 0) {
          this._router.navigate([environment.welcomeLogOutUrl]);
        } else {
          window.location.href= environment.welcomeLogOutUrl
        }
      }
    });
  }

  private openDoor() {
    this.state = 'doorOpen';
  }

  private closeDoor() {
    this.restrictedTitle = 'Access Denied';
    this.restrictedSubtitle = 'Please Login';
    this.state = 'doorClosed';
    TokenManager.token = null;
    LabIdManager.labId = null;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/app.component.ts